import * as React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import {Tooltip} from '@mui/material';
import {Button} from '@material-ui/core';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper'; 
import FilesSave from './FilesSave';
import IframeDialog from '../components/IframeDialog';
import DeleteAlert from '../components/DeleteAlert';
import Alert from '../components/Alert';
import {API_URL} from '../utils/EnvVars';
import axios from 'axios';
import {Edit} from '@mui/icons-material';


export default function BasicTable(props) {
  const childRefSave = React.useRef();
  const childRefAlert = React.useRef(); 
  const childRefIframe = React.useRef();  
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [alertMessage, setAlertMessage] = React.useState("");

  const [rows, setRows] = React.useState([]);
  const [dataObj, setDataObj] = React.useState({});
  const [fileUrl, setFileUrl] = React.useState("");

  React.useEffect(() => {
    setRows(props.rows);
  }, [props.rows]);

  function add() { 
      setDataObj({});
      childRefSave.current.handleClickOpen();
  }

  function edit(obj) { 
      setDataObj(obj);
      childRefSave.current.handleClickOpen();
  }

  function updatedList(list){
      setRows(list);
      props.filesUpdatedList(list);
  }

  function deleteNow(obj){
		if(obj && obj!=null && props.userObj){
			let apiUrl=API_URL+'/crm-delete-files';
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': props.userObj.registerId,
					'uid': props.userObj.loginId,
					'fullName': props.userObj.fullName,
					'token': props.userObj.token,
				}
			};
  
		  const data = new FormData();
		  data.append('id', obj.autoId);				 
      data.append('relatedTo', props.relatedTo);
      data.append('relatedToId', props.relatedToId);
      data.append('relatedTitle', props.relatedTitle);

		  axios.post(apiUrl, data, axiosHeader)
				.then((response) => {
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");					
					setAlertMessage("File has been deleted.");
          childRefAlert.current.handleClickOpen();
          setRows(response.data.list);
					return false;
				}else{
			  	setSeverityAlert("error");
					setAlertMessage("File could not be deleted.");		
          childRefAlert.current.handleClickOpen();	
					return false;
				}
			})
			.catch((error) => {
          setSeverityAlert("error");
					setAlertMessage(" "+error);		
          childRefAlert.current.handleClickOpen();	
					return false;
			})	
		}		
	
		
	}

  function fileOpen(url) { 
    setFileUrl(url);
    childRefIframe.current.handleClickOpen();    
  }

  return (<>
    {(props.privilegesFiles && props.privilegesFiles.indexOf("create")>-1)?
      <div style={{textAlign:'center',marginBottom:10}}>
          <Button onClick={() => {add()}} style={{textTransform:'none',maxHeight:25}} size="small" variant="outlined" >Add File</Button>
      </div>
    :null}
    {props.linearProgress?<LinearProgress />:null}
    <TableContainer component={Paper}>
      <Table sx={{ width: '100%' }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>File Name</TableCell>
            <TableCell>Remarks</TableCell>            
            <TableCell>Last Modified By</TableCell>
            <TableCell style={{textAlign:'center'}}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?rows.map((row) => (
            <TableRow
              key={row.autoId}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row" onClick={()=>{fileOpen(row.fileUrl)}} style={{cursor:'pointer'}} >                
                {row.fileNameOriginal}              
              </TableCell>              
              <TableCell>{row.description}</TableCell>
              <TableCell>{row.lastModifiedAlias} {row.lastModifiedDateTime}</TableCell>
              <TableCell style={{textAlign:'center'}} >
              {(props.privilegesFiles && ((props.privilegesFiles.indexOf("update")>-1 ) || props.privilegesFiles.indexOf("modifyall")>-1) )?
                <Tooltip title={'Edit, Last Modified By: '+row.lastModifiedAlias+', '+row.lastModifiedDateTime} arrow>
                    <Edit className='iconGraySmall' onClick={()=>{edit(row)}}  />
                </Tooltip>
              :null}  
              {(props.privilegesFiles && props.privilegesFiles.indexOf("delete")>-1)?  
                <DeleteAlert deleteNow={deleteNow} dataObj={row} text={'Are you sure, You want to delete file.'} className='iconGraySmall' />
              :null}
              </TableCell>
            </TableRow>
          )):null}
        </TableBody>
      </Table>
    </TableContainer>

    {(!rows || rows.length<1)?<div className='nrfbox'>No file found</div>:null}  

    <FilesSave dataObj={dataObj} relatedTo={props.relatedTo} relatedToId={props.relatedToId} relatedTitle={props.relatedTitle} updatedList={updatedList} activityTypeList={props.activityTypeList} userObj={props.userObj} ref={childRefSave} />
              
    <Alert severityAlert={severityAlert} alertMessage={alertMessage} ref={childRefAlert} />          

    <IframeDialog url={fileUrl} ref={childRefIframe} />        

    </>
  );
}
